import { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const PHONES = ["0705943820", "0790594148"];
const EMAIL = "nextgendiani@gmail.com";

function Help() {
  const team = useLocation().state?.team;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-brand-cream">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        team={team}
      />

      <div className="flex-1 p-6">
        <button
          onClick={() => setSidebarOpen(true)}
          className="md:hidden mb-4 bg-brand-dark text-white px-3 py-2 rounded-lg text-xl"
        >
          ☰
        </button>

        <h1 className="text-2xl font-bold text-brand-red mb-1">
          Help & Support
        </h1>
        <p className="text-sm text-gray-600 mb-6">
          Need a hand? Call us or email us and we'll get back to you.
        </p>

        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-white rounded-2xl shadow p-5">
            <h2 className="text-lg font-bold text-brand-dark mb-1">
              Call us
            </h2>
            <p className="text-sm text-gray-500 mb-4">
              Tap a number to call.
            </p>
            <div className="space-y-2">
              {PHONES.map((phone) => (
                <a
                  key={phone}
                  href={`tel:${phone}`}
                  className="block w-full text-center bg-brand-red text-white font-bold py-2.5 rounded-lg hover:bg-red-800"
                >
                  {phone}
                </a>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow p-5">
            <h2 className="text-lg font-bold text-brand-dark mb-1">
               Email us
            </h2>
            <p className="text-sm text-gray-500 mb-4">
              Tap to open your email app.
            </p>
            <a
              href={`mailto:${EMAIL}`}
              className="block w-full text-center bg-brand-gold text-brand-dark font-bold py-2.5 rounded-lg hover:opacity-90 break-all"
            >
              {EMAIL}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;